import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';

import { OfficeHoursService } from '@shared/services/office-hours/office-hours.service';

@Component({
  selector: 'app-office-hours',
  templateUrl: './office-hours.component.html',
  styleUrl: './office-hours.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage],
  providers: [OfficeHoursService],
})
export class OfficeHoursComponent implements OnInit {
  officeHoursService = inject(OfficeHoursService);

  readonly officeHours = toSignal(this.officeHoursService.getOfficeHours$(), { requireSync: true });

  ngOnInit() {
    this.officeHoursService.initialiseSchedule();
  }
}
